export const SlideInAnimation = ({
  children,
  shouldAnimate = true,
}: {
  children: React.ReactNode;
  shouldAnimate?: boolean;
}) =>
  shouldAnimate ? (
    <div className="animate-slide-in">{children}</div>
  ) : (
    <>{children}</>
  );
